import { WeekViewActions, WeekViewCurrentTip } from "@actions/week-view.actions";

export interface IWeekViewState {
  currentTip: WeekViewCurrentTip;
}

export interface IWeekViewActionData {
  currentTip: WeekViewCurrentTip;
}

interface IWeekViewAction {
  type: WeekViewActions;
  data: IWeekViewActionData;
}

export const initialWeekViewState: IWeekViewState = {
  currentTip: WeekViewCurrentTip.None,
};

export function weekViewReducer(
  state: IWeekViewState = initialWeekViewState,
  action: IWeekViewAction,
) {
  switch (action.type) {
    case WeekViewActions.SetCurrentTip:
      return { ...state, currentTip: action.data.currentTip };
    default:
      return state;
  }
}
